export const ADD_TO_CART = 'addToCart'
export const CLEAR_CART = 'clearCart'
export const CART_CONFIRMATION = 'cartConfirmation'
export const DELETE_CART = 'deleteCart'
export const DELETE_CART_LINE = 'deleteCartLine'
export const GET_CART = 'getCart'
export const GET_FINALIZED_CART = 'getFinalizedCart'
export const REOPEN_CART = 'reopenCart'
